import { render, staticRenderFns } from "./VoicemailLog.vue?vue&type=template&id=3081b63a&"
import script from "./VoicemailLog.vue?vue&type=script&lang=js&"
export * from "./VoicemailLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports